import moment from 'moment';

export function toLocalDateTimeStr(l: number): string {
  return moment(l).format('YYYY-MM-DD HH:mm:ss');
}

// 날짜시분초에 대해 언어 별 포맷 적용
export function toLocalDateTimeLangStr(l: number, lang: string): string {
  if (lang === 'ko') {
    return moment(l).format('YYYY-MM-DD HH:mm:ss');
  } else {
    return moment(l).format('MM/DD/YYYY HH:mm:ss');
  }
}
// 날짜시분에 대해 언어 별 포맷 적용
export function toLocalDateMinLangStr(l: number, lang: string): string {
  if (lang === 'ko') {
    return moment(l).format('YYYY-MM-DD HH:mm');
  } else {
    return moment(l).format('MM/DD/YYYY HH:mm');
  }
}

// 날짜에 대해 언어 별 포맷 적용
export function toLocalDateLangStr(l: number, lang: string): string {
  if (lang === 'ko') {
    return moment(l).format('YYYY-MM-DD');
  } else {
    return moment(l).format('MM/DD/YYYY');
  }
}

export function toLocalDateStr(l: number): string {
  return moment(l).format('YYYYMMDD');
}

export function dateToStringByFormat(date: Date, format: string): string {
  return moment(date).format(format);
}

export function stringToDate(str: string): Date {
  return moment(str).toDate();
}

export function toLocalDateWithFormat(l: number, format: string): string {
  return moment(l).format(format);
}
